/**
 * Webhooks Page
 * Webhook subscription configuration and management
 */

import { useState } from 'react';
import toast from 'react-hot-toast';
import { Plus, Webhook, Zap } from 'lucide-react';
import EmptyState from '../components/shared/EmptyState';

const EVENT_TYPES = [
  { key: 'sentiment.analyzed', label: 'Sentiment Analyzed', description: 'Fires when a new sentiment analysis is completed' },
  { key: 'qa.scored', label: 'QA Scored', description: 'Fires when a QA score is computed for an interaction' },
  { key: 'compliance.flagged', label: 'Compliance Flagged', description: 'Fires when a compliance violation is detected' },
];

const WebhooksPage = () => {
  const [showForm, setShowForm] = useState(false);

  return (
    <div>
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-sm font-semibold text-gray-700">Webhook Subscriptions</h2>
          <p className="text-xs text-gray-500 mt-0.5">Receive real-time notifications when events occur in the platform.</p>
        </div>
        <button
          onClick={() => { setShowForm(true); toast('Webhook creation coming soon'); }}
          className="btn-primary text-xs py-1.5 px-3 flex items-center space-x-1"
        >
          <Plus size={14} />
          <span>Add Webhook</span>
        </button>
      </div>

      {/* Available events info */}
      <div className="card p-5 mb-6">
        <h3 className="text-sm font-semibold text-gray-700 mb-3 flex items-center space-x-2">
          <Zap size={16} className="text-amber-500" />
          <span>Available Events</span>
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {EVENT_TYPES.map(event => (
            <div key={event.key} className="flex items-start space-x-3 p-3 bg-gray-50 rounded-lg">
              <Webhook size={16} className="text-gray-400 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-gray-800">{event.label}</p>
                <p className="text-xs text-gray-500">{event.description}</p>
                <code className="text-xs text-primary-600 mt-1 block">{event.key}</code>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Empty subscription list */}
      <EmptyState
        title="No webhook subscriptions"
        description="Add a webhook to start receiving real-time event notifications."
        icon={Webhook}
      />
    </div>
  );
};

export default WebhooksPage;
